{
  "slots": {
    "weapon1": ["pdc"],
    "weapon2": ["laser"],
    "miningLaser": ["mining"],
    "salvageBeam": ["salvage"],
    "cargo": ["cargo"],
    "shield": ["shield"],
    "power": ["power"],
    "thrusters": ["thrusters"],
    "scanner": ["scanner"]
  },
  "sellFraction": 0.6,
  "scrapFraction": 0.4,
  "materials": { "shortage": { "maxListed": 5 } },
  "weapons": { "pdc": "pdc", "laser": "pulseLaser" },
  "modules": [
    { "id": "pdc.mk1", "name": "PDC Mk I", "price": 6000, "power": 2, "stats": { "damageMult": 1.0 } },
    {
      "id": "pdc.mk2",
      "name": "PDC Mk II",
      "price": 18000,
      "power": 3,
      "stats": { "damageMult": 1.15 },
      "materials": { "creditShare": 0.7, "inputs": { "steel": 4, "weapon_parts": 1, "platinum": 1 }, "carry": "platinum", "salvageAlt": { "component": "weapon", "replaces": "platinum", "minBand": "serviceable" }, "where": "any" }
    },
    {
      "id": "pdc.mk3",
      "name": "PDC Mk III",
      "price": 55000,
      "power": 4,
      "stats": { "damageMult": 1.3 },
      "materials": { "creditShare": 0.5, "inputs": { "ti_alloy": 6, "weapon_parts": 6, "electronics": 4, "refractory_alloy": 2 }, "carry": "refractory_alloy", "where": "fabworks" }
    },
    { "id": "laser.mk1", "name": "Pulse Laser Mk I", "price": 6000, "power": 2, "stats": { "damageMult": 1.0 } },
    {
      "id": "laser.mk2",
      "name": "Pulse Laser Mk II",
      "price": 18000,
      "power": 3,
      "stats": { "damageMult": 1.15 },
      "materials": { "creditShare": 0.7, "inputs": { "silicon_wafers": 4, "weapon_parts": 1, "platinum": 1 }, "carry": "platinum", "salvageAlt": { "component": "weapon", "replaces": "platinum", "minBand": "serviceable" }, "where": "any" }
    },
    {
      "id": "laser.mk3",
      "name": "Pulse Laser Mk III",
      "price": 55000,
      "power": 4,
      "stats": { "damageMult": 1.3 },
      "materials": { "creditShare": 0.5, "inputs": { "silicon_wafers": 6, "electronics": 6, "weapon_parts": 5, "refractory_alloy": 2 }, "carry": "refractory_alloy", "where": "fabworks" }
    },
    {
      "id": "mining.mk1",
      "name": "Mining Laser Mk I",
      "price": 7000,
      "power": 2,
      "stats": { "maxPower": 0.7, "heatCapacityMult": 1.0, "chipRateMult": 1.0, "maxTier": 1 }
    },
    {
      "id": "mining.mk2",
      "name": "Mining Laser Mk II",
      "price": 20000,
      "power": 3,
      "stats": { "maxPower": 0.85, "heatCapacityMult": 1.3, "chipRateMult": 1.25, "maxTier": 2 },
      "materials": { "creditShare": 0.7, "inputs": { "steel": 4, "ti_alloy": 1, "electronics": 1, "platinum": 1 }, "carry": "platinum", "salvageAlt": { "component": "radiator", "replaces": "platinum", "minBand": "serviceable" }, "where": "any" }
    },
    {
      "id": "mining.mk3",
      "name": "Mining Laser Mk III",
      "price": 60000,
      "power": 4,
      "stats": { "maxPower": 1.0, "heatCapacityMult": 1.6, "chipRateMult": 1.5, "maxTier": 2 },
      "materials": { "creditShare": 0.5, "inputs": { "ti_alloy": 8, "electronics": 6, "drive_parts": 1, "platinum": 4 }, "carry": "platinum", "where": "fabworks" }
    },
    { "id": "salvage.mk1", "name": "Salvage Beam Mk I", "price": 5000, "power": 1, "stats": { "cutMult": 1.0, "spillPerSec": 0.02, "tractorRange": 80 } },
    {
      "id": "salvage.mk2",
      "name": "Salvage Beam Mk II",
      "price": 16000,
      "power": 2,
      "stats": { "cutMult": 0.8, "spillPerSec": 0.013, "tractorRange": 120 },
      "materials": { "creditShare": 0.7, "inputs": { "steel": 6, "electronics": 1, "platinum": 1 }, "carry": "platinum", "salvageAlt": { "component": "radiator", "replaces": "platinum", "minBand": "serviceable" }, "where": "any" }
    },
    {
      "id": "salvage.mk3",
      "name": "Salvage Beam Mk III",
      "price": 48000,
      "power": 3,
      "stats": { "cutMult": 0.65, "spillPerSec": 0.008, "tractorRange": 160 },
      "materials": { "creditShare": 0.5, "inputs": { "ti_alloy": 6, "titanium": 4, "electronics": 4, "drive_parts": 1, "platinum": 3 }, "carry": "platinum", "where": "fabworks" }
    },
    { "id": "cargo.mk1", "name": "Cargo Racks Mk I", "price": 5000, "power": 0, "stats": { "capacityT": 20, "maxPartMassT": 4 } },
    {
      "id": "cargo.mk2",
      "name": "Cargo Racks Mk II",
      "price": 15000,
      "power": 1,
      "stats": { "capacityT": 35, "maxPartMassT": 6 },
      "materials": { "creditShare": 0.13, "inputs": { "steel": 10, "hull_plating": 1 }, "carry": "dataCore", "where": "any" }
    },
    {
      "id": "cargo.mk3",
      "name": "Cargo Racks Mk III",
      "price": 45000,
      "power": 1,
      "stats": { "capacityT": 50, "maxPartMassT": 8 },
      "materials": { "creditShare": 0.5, "inputs": { "ti_alloy": 6, "hull_plating": 8, "platinum": 3 }, "carry": "platinum", "where": "fabworks" }
    },
    { "id": "shield.mk1", "name": "Shield Generator Mk I", "price": 7000, "power": 2, "stats": { "shieldMult": 1.0, "regenMult": 1.0 } },
    {
      "id": "shield.mk2",
      "name": "Shield Generator Mk II",
      "price": 22000,
      "power": 3,
      "stats": { "shieldMult": 1.25, "regenMult": 1.2 },
      "materials": { "creditShare": 0.7, "inputs": { "silicon_wafers": 2, "electronics": 1, "platinum": 2 }, "carry": "platinum", "salvageAlt": { "component": "shieldGen", "replaces": "platinum", "minBand": "serviceable" }, "where": "any" }
    },
    {
      "id": "shield.mk3",
      "name": "Shield Generator Mk III",
      "price": 65000,
      "power": 4,
      "stats": { "shieldMult": 1.5, "regenMult": 1.4 },
      "materials": { "creditShare": 0.5, "inputs": { "ti_alloy": 6, "electronics": 10, "refractory_alloy": 2 }, "carry": "refractory_alloy", "where": "fabworks" }
    },
    { "id": "power.mk1", "name": "Power Plant Mk I", "price": 8000, "power": 0, "stats": { "budget": 12 } },
    {
      "id": "power.mk2",
      "name": "Power Plant Mk II",
      "price": 25000,
      "power": 0,
      "stats": { "budget": 16 },
      "materials": { "creditShare": 0.7, "inputs": { "steel": 4, "electronics": 1, "platinum": 2 }, "carry": "platinum", "salvageAlt": { "component": "radiator", "replaces": "platinum", "minBand": "serviceable" }, "where": "any" }
    },
    {
      "id": "power.mk3",
      "name": "Power Plant Mk III",
      "price": 70000,
      "power": 0,
      "stats": { "budget": 20 },
      "materials": {
        "creditShare": 0.5,
        "inputs": { "steel": 6, "electronics": 8, "drive_parts": 2, "refractory_alloy": 2 },
        "carry": "refractory_alloy",
        "salvageAlt": { "component": "reactor", "replaces": "electronics", "minBand": "intact" },
        "where": "fabworks"
      }
    },
    { "id": "thrusters.mk1", "name": "Thrusters Mk I", "price": 6000, "power": 1, "stats": { "thrustMult": 1.0, "maxSpeedAdd": 0 } },
    {
      "id": "thrusters.mk2",
      "name": "Thrusters Mk II",
      "price": 20000,
      "power": 2,
      "stats": { "thrustMult": 1.1, "maxSpeedAdd": 10 },
      "materials": { "creditShare": 0.7, "inputs": { "steel": 4, "drive_parts": 1, "platinum": 1 }, "carry": "platinum", "salvageAlt": { "component": "thruster", "replaces": "platinum", "minBand": "serviceable" }, "where": "any" }
    },
    {
      "id": "thrusters.mk3",
      "name": "Thrusters Mk III",
      "price": 60000,
      "power": 3,
      "stats": { "thrustMult": 1.2, "maxSpeedAdd": 20 },
      "materials": { "creditShare": 0.5, "inputs": { "ti_alloy": 6, "drive_parts": 5, "refractory_alloy": 2 }, "carry": "refractory_alloy", "where": "fabworks" }
    },
    { "id": "scanner.mk1", "name": "Scanner Mk I", "price": 3000, "power": 1, "stats": { "range": 1500, "accuracy": "range" } },
    {
      "id": "scanner.mk2",
      "name": "Scanner Mk II",
      "price": 10000,
      "power": 1,
      "stats": { "range": 2500, "accuracy": "pm10" },
      "materials": { "creditShare": 0.7, "inputs": { "silicon_wafers": 2, "platinum": 1 }, "carry": "platinum", "salvageAlt": { "component": "radiator", "replaces": "platinum", "minBand": "serviceable" }, "where": "any" }
    },
    {
      "id": "scanner.mk3",
      "name": "Scanner Mk III",
      "price": 30000,
      "power": 2,
      "stats": { "range": 4000, "accuracy": "exact" },
      "materials": { "creditShare": 0.19, "inputs": { "electronics": 8, "silicon_wafers": 4, "ti_alloy": 2 }, "carry": "dataCore", "where": "fabworks" }
    }
  ],
  "utility": {
    "escapePod": { "name": "Escape Pod", "price": 15000, "power": 0, "stats": {} },
    "heavyTractor": { "name": "Heavy Tractor", "price": 45000, "power": 2, "stats": { "maxPartMassT": 20 } },
    "resonanceMeter": { "name": "Resonance Meter", "price": 25000, "power": 0, "stats": {} }
  }
}
